import { patientStore } from '@patientMenu/store/patientStore';

export const usePatientStore = () => {
  const selectedPatients = patientStore((state) => state.selectedPatients);
  const setSelectedPatients = patientStore((state) => state.setSelectedPatients);

  const query = patientStore((state) => state.query);
  const setQuery = patientStore((state) => state.setQuery);

  const pageable = patientStore((state) => state.pageable);
  const setPageable = patientStore((state) => state.setPageable);

  return {
    selectedPatients,
    setSelectedPatients,
    query,
    setQuery,
    pageable,
    setPageable,
  };
};

export default usePatientStore;
